import axios from "axios";

import SignOut from "../components/SignIn/SignOut";
const store = require("store");

const getNameList = async () => {
  const getName = `/pil/attr/name`;
  let result;
  try {
    let headers = {
      Authorization: "Bearer " + store.get("access_token"),
      site: store.get("site"),
      locale: store.get("locale"),
    };

    result = await axios({
      method: "get",
      url: process.env.REACT_APP_API_URL_3013 + getName,
      headers: headers,
    });

    return result.data;
  } catch (error) {
    try {
      if (error.response.status === 401) {
        // DoRefreshToken()
        SignOut();
      } else {
        throw new Error(error);
      }
    } catch (error) {
      throw new Error(error);
    }
  }
};

const getPILContractList = async () => {
  const getPILContract = `/pil/attr/contract`;
  let result;
  try {
    let headers = {
      Authorization: "Bearer " + store.get("access_token"),
      site: store.get("site"),
      locale: store.get("locale"),
    };

    result = await axios({
      method: "get",
      url: process.env.REACT_APP_API_URL_3013 + getPILContract,
      headers: headers,
    });

    return result.data;
  } catch (error) {
    try {
      if (error.response.status === 401) {
        // DoRefreshToken()
        SignOut();
      } else {
        throw new Error(error);
      }
    } catch (error) {
      throw new Error(error);
    }
  }
};

const getPILPaymentList = async () => {
  const getPILPayment = `/pil/attr/paymentterm`;
  let result;
  try {
    let headers = {
      Authorization: "Bearer " + store.get("access_token"),
      site: store.get("site"),
      locale: store.get("locale"),
    };

    result = await axios({
      method: "get",
      url: process.env.REACT_APP_API_URL_3013 + getPILPayment,
      headers: headers,
    });

    return result.data;
  } catch (error) {
    try {
      if (error.response.status === 401) {
        // DoRefreshToken()
        SignOut();
      } else {
        throw new Error(error);
      }
    } catch (error) {
      throw new Error(error);
    }
  }
};

const getPILBreakDownList = async () => {
  const getPILBreakDown = `/pil/attr/breakdown`;
  let result;
  try {
    let headers = {
      Authorization: "Bearer " + store.get("access_token"),
      site: store.get("site"),
      locale: store.get("locale"),
    };

    result = await axios({
      method: "get",
      url: process.env.REACT_APP_API_URL_3013 + getPILBreakDown,
      headers: headers,
    });

    return result.data;
  } catch (error) {
    try {
      if (error.response.status === 401) {
        // DoRefreshToken()
        SignOut();
      } else {
        throw new Error(error);
      }
    } catch (error) {
      throw new Error(error);
    }
  }
};

const getPILMainConList = async () => {
  const getPILMaincon = `/pil/attr/maincon`;
  let result;
  try {
    let headers = {
      Authorization: "Bearer " + store.get("access_token"),
      site: store.get("site"),
      locale: store.get("locale"),
    };

    result = await axios({
      method: "get",
      url: process.env.REACT_APP_API_URL_3013 + getPILMaincon,
      headers: headers,
    });

    return result.data;
  } catch (error) {
    try {
      if (error.response.status === 401) {
        // DoRefreshToken()
        SignOut();
      } else {
        throw new Error(error);
      }
    } catch (error) {
      throw new Error(error);
    }
  }
};

const getPILConManagerList = async () => {
  const getPILConManager = `/pil/attr/conmanager`;
  let result;
  try {
    let headers = {
      Authorization: "Bearer " + store.get("access_token"),
      site: store.get("site"),
      locale: store.get("locale"),
    };

    result = await axios({
      method: "get",
      url: process.env.REACT_APP_API_URL_3013 + getPILConManager,
      headers: headers,
    });

    return result.data;
  } catch (error) {
    try {
      if (error.response.status === 401) {
        // DoRefreshToken()
        SignOut();
      } else {
        throw new Error(error);
      }
    } catch (error) {
      throw new Error(error);
    }
  }
};

const getPILDetails = async () => {
  const getPil = `/pil`;
  let result;
  try {
    let headers = {
      Authorization: "Bearer " + store.get("access_token"),
      site: store.get("site"),
      locale: store.get("locale"),
    };

    result = await axios({
      method: "get",
      url: process.env.REACT_APP_API_URL_3013 + getPil,
      headers: headers,
    });

    return result.data;
  } catch (error) {
    try {
      if (error.response.status === 401) {
        // DoRefreshToken()
        SignOut();
      } else {
        throw new Error(error);
      }
    } catch (error) {
      throw new Error(error);
    }
  }
};

const updatePilDetails = async (pil_seq, params) => {
  const updatePil = `/pil/${pil_seq}`;
  let result;
  try {
    let headers = {
      Authorization: "Bearer " + store.get("access_token"),
      site: store.get("site"),
      locale: store.get("locale"),
    };

    result = await axios({
      method: "patch",
      url: process.env.REACT_APP_API_URL_3013 + updatePil,
      headers: headers,
      data: params,
    });

    return result.data;
  } catch (error) {
    try {
      if (error.response.status === 401) {
        // DoRefreshToken()
        SignOut();
      } else {
        throw new Error(error);
      }
    } catch (error) {
      throw new Error(error);
    }
  }
};

const getPILPrintConfig = async (pil_seq) => {
  const getPilPrint = `/pil/${pil_seq}/print`;
  let result;
  try {
    let headers = {
      Authorization: "Bearer " + store.get("access_token"),
      site: store.get("site"),
      locale: store.get("locale"),
    };

    result = await axios({
      method: "get",
      url: process.env.REACT_APP_API_URL_3013 + getPilPrint,
      headers: headers,
    });

    return result.data;
  } catch (error) {
    try {
      if (error.response.status === 401) {
        // DoRefreshToken()
        SignOut();
      } else {
        throw new Error(error);
      }
    } catch (error) {
      throw new Error(error);
    }
  }
};

const updatePILPrintConfig = async (pil_seq, params) => {
  const updatePilPrint = `/pil/${pil_seq}/print`;
  let result;
  try {
    let headers = {
      Authorization: "Bearer " + store.get("access_token"),
      site: store.get("site"),
      locale: store.get("locale"),
    };

    result = await axios({
      method: "patch",
      url: process.env.REACT_APP_API_URL_3013 + updatePilPrint,
      headers: headers,
      data: params,
    });

    return result.data;
  } catch (error) {
    try {
      if (error.response.status === 401) {
        // DoRefreshToken()
        SignOut();
      } else {
        throw new Error(error);
      }
    } catch (error) {
      throw new Error(error);
    }
  }
};

const getPILNature = async () => {
  const getPil = `/pil/new/cde/get_site_natures`; // need to change the path later
  let result;
  try {
    let headers = {
      Authorization: "Bearer " + store.get("access_token"),
      site: store.get("site"),
      locale: store.get("locale"),
    };

    result = await axios({
      method: "get",
      url: process.env.REACT_APP_API_URL_3013 + getPil,
      headers: headers,
    });

    return result.data;
  } catch (error) {
    try {
      if (error.response.status === 401) {
        // DoRefreshToken()
        SignOut();
      } else {
        throw new Error(error);
      }
    } catch (error) {
      throw new Error(error);
    }
  }
};

const generatePdf = async (html, filename) => {
  const str = window.btoa(unescape(encodeURIComponent(html)));
  // Send a safe random name in the request so WAF/server checks won't block
  // special characters. The real download name is set by the caller via
  // FileSaver.saveAs(pdf, `${filename}.pdf`) (or equivalent).
  const requestFilename = `doc${Date.now()}${Math.random()
    .toString(36)
    .slice(2, 10)}.pdf`;
  return axios
    .create({
      baseURL: process.env.REACT_APP_GENERATE_PDF_API,
      responseType: "blob",
    })
    .post(`/pdf?filename=${requestFilename}`, str)
    .then((result) => {
      if (result.data === undefined) throw new Error("No Data");
      else return result.data;
    })
    .catch((error) => {
      return error;
    });
};

const updatePilPrintFlag = async (pil_seq) => {
  const updatePilPrintFlag = `/pil/${pil_seq}/printflag`;
  let result;
  try {
    let headers = {
      Authorization: "Bearer " + store.get("access_token"),
      site: store.get("site"),
      locale: store.get("locale"),
    };

    result = await axios({
      method: "patch",
      url: process.env.REACT_APP_API_URL_3013 + updatePilPrintFlag,
      headers: headers,
    });

    return result.data;
  } catch (error) {
    try {
      if (error.response.status === 401) {
        // DoRefreshToken()
        SignOut();
      } else {
        throw new Error(error);
      }
    } catch (error) {
      throw new Error(error);
    }
  }
};

const insertPilAttachment = async (pil_seq, data) => {
  const updatePilPrintFlag = `/pil/${pil_seq}/upload`;
  let result;
  try {
    let headers = {
      Authorization: "Bearer " + store.get("access_token"),
      site: store.get("site"),
      locale: store.get("locale"),
    };

    result = await axios({
      method: "post",
      url: process.env.REACT_APP_API_URL_3013 + updatePilPrintFlag,
      headers: headers,
      data: data,
    });

    return result.data;
  } catch (error) {
    try {
      if (error.response.status === 401) {
        // DoRefreshToken()
        SignOut();
      } else {
        throw new Error(error);
      }
    } catch (error) {
      throw new Error(error);
    }
  }
};

const deletePilAttachment = async (atth_seq) => {
  const updatePilPrintFlag = `/pil/${atth_seq}/upload`;
  let result;
  try {
    let headers = {
      Authorization: "Bearer " + store.get("access_token"),
      site: store.get("site"),
      locale: store.get("locale"),
    };

    result = await axios({
      method: "delete",
      url: process.env.REACT_APP_API_URL_3013 + updatePilPrintFlag,
      headers: headers,
    });

    return result.data;
  } catch (error) {
    try {
      if (error.response.status === 401) {
        // DoRefreshToken()
        SignOut();
      } else {
        throw new Error(error);
      }
    } catch (error) {
      throw new Error(error);
    }
  }
};

const getProjCodeList = async () => {
  const getProjCode = `/opcode`;
  let result;
  try {
    let headers = {
      Authorization: "Bearer " + store.get("access_token"),
      site: store.get("site"),
      locale: store.get("locale"),
    };

    result = await axios({
      method: "get",
      url: process.env.REACT_APP_API_URL_3013 + getProjCode,
      headers: headers,
    });

    return result.data;
  } catch (error) {
    try {
      if (error.response.status === 401) {
        // DoRefreshToken()
        SignOut();
      } else {
        throw new Error(error);
      }
    } catch (error) {
      throw new Error(error);
    }
  }
};

const lockPilData = async (pil_seq) => {
    const path = `/pil/${pil_seq}/lock`;
    let result;
    try {
        let headers = {
            Authorization: "Bearer " + store.get("access_token"),
            site: store.get("site"),
            locale: store.get("locale"),
        };

        result = await axios({
            method: "post",
            url: process.env.REACT_APP_API_URL_3013 + path,
            headers: headers,
        });

        return result.data;
    } catch (error) {
        try {
            if (error.response.status === 401) {
                SignOut();
            } else {
                throw new Error(error);
            }
        } catch (error) {
            throw new Error(error);
        }
    }
};


const getLockRight = async (pil_seq) => {
  const path = `/pil/lock/right`;
  let result;
  try {
    let headers = {
      Authorization: "Bearer " + store.get("access_token"),
      site: store.get("site"),
      locale: store.get("locale"),
    };

    result = await axios({
      method: "get",
      url: process.env.REACT_APP_API_URL_3013 + path,
      headers: headers
    });

    return result.data;
  } catch (error) {
    try {
      if (error.response.status === 401) {
        SignOut();
      } else {
        throw new Error(error);
      }
    } catch (error) {
      throw new Error(error);
    }
  }
};

export {
  getPILContractList,
  getPILPaymentList,
  getPILBreakDownList,
  getPILMainConList,
  getPILConManagerList,
  getPILDetails,
  getPILPrintConfig,
  getPILNature,
  updatePilDetails,
  updatePILPrintConfig,
  generatePdf,
  updatePilPrintFlag,
  insertPilAttachment,
  deletePilAttachment,
  getNameList,
  getProjCodeList,
  lockPilData,
  getLockRight
};
